import React from 'react';
import { Quote } from 'lucide-react';
import { TESTIMONIALS } from '../data/mock';
import SectionHeading from './SectionHeading';

const Testimonials = () => {
  return (
    <section id="testimonials" className="section-pad bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <SectionHeading
          eyebrow="Client Love"
          title="What Our"
          accent="Guests"
          tail="Say"
          subtitle="Real notes from real hosts across India."
        />

        <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {TESTIMONIALS.map((t, i) => (
            <blockquote
              key={t.name}
              className="relative rounded-3xl bg-blush/60 border border-pink-100 p-7 shadow-soft"
              style={{ animationDelay: `${i * 60}ms` }}
              data-testid={`testimonial-${t.name.toLowerCase().replace(/\s+/g, '-')}`}
            >
              <Quote className="w-8 h-8 text-pink-brand/40 mb-3" />
              <p className="text-stone-700 italic leading-relaxed">"{t.text}"</p>
              <footer className="mt-5 flex items-center gap-3">
                <div className="w-10 h-10 rounded-full bg-pink-brand text-white flex items-center justify-center font-display font-bold">
                  {t.name.charAt(0)}
                </div>
                <div>
                  <div className="font-semibold text-stone-900 text-sm">{t.name}</div>
                  <div className="text-xs text-stone-500">{t.city}</div>
                </div>
              </footer>
            </blockquote>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
